<template>
  <div class="flex items-center justify-center h-full">
    <div class="text-center">
      <div
        class="text-[24px] md:text-[30px] font-normal md:font-thin text-white mb-10 px-12 md:px-0"
      >
        No access
      </div>
      <div class="text-neutral-400">You don't have access to this page</div>
    </div>
  </div>
</template>
